import axios from 'axios';

/**
 * Axios response interceptor: on 401 (Invalid token, expired session),
 * clear auth, set flag for Login page, and redirect to login.
 * Skips the login endpoint to avoid redirect loops on bad credentials.
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/auth/login');
      if (!isLoginRequest) {
        localStorage.removeItem('token');
        localStorage.removeItem('admin');
        sessionStorage.setItem('loginExpired', '1');
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);
